import { ValidatorProvider } from '@dofleini/validator';
import { Form } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '@/components/Tooltip';
import { CACHE_KEY_LIST_DPJ_OFFICE } from '@/modules/configuration/contants/dpjOffice';
import DpjOfficeApiService from '@/modules/configuration/services/DpjOfficeApiService';
import { renderMunicipality, renderProvince } from '@/utils/location';
import SelectElementCmp from '@/utils/SelectElementCmp';

import style from './index.less';

const DPJNotariesSelect = ({ value, onChange, filters, ...props }) => {
  const { t } = useTranslation('common');
  const currentValue = value && typeof value === 'object' ? value._id : value;
  
  const onRenderItem = useCallback(({ name, address }) => {
    return <div className="truncate">
      <div className="flex items-center truncate">{name}</div>
      <>
        <div className={classNames('flex items-center truncate gap-x-1')}>
          {address?.province &&
          <div className="element-contact text-xs truncate">{renderProvince(address?.province)}</div>}
          {address?.municipality &&
          <div className="element-contact text-xs truncate">{renderMunicipality(address?.municipality)}</div>}
        </div>
        <Tooltip title={address.abstract}>
          {address?.abstract &&
          <div className="element-contact text-xs truncate">{address.abstract}</div>}
        </Tooltip>
      </>
    </div>;
  }, []);
  
  return (
    <>
      <div className={classNames('w-full', style.container)}>
        <SelectElementCmp
          {...props}
          queryKey={CACHE_KEY_LIST_DPJ_OFFICE}
          filters={filters}
          service={DpjOfficeApiService}
          includeValue={value}
          value={currentValue}
          placeholder={t('selectPlaceholder')}
          onChange={onChange}
          customItemRender={onRenderItem}
          customMapItem={(v) => ({ ...v, name: `(${v.code}) ${v.name}` })}
          queryConfig={{ refetchOnWindowFocus: false }}
        />
      </div>
    </>
  );
};

DPJNotariesSelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  showContact: PropTypes.bool,
  filters: PropTypes.object
};

export default memo(DPJNotariesSelect);

export const renderDPJNotariesSelect = ({ formItemProps, field, form }) => {
  
  const rules = field?.required && [{ required: true, message: ValidatorProvider.t('validateMessages.required') }];
  
  return (
    <Form.Item {...formItemProps} required={field?.required} rules={rules}>
      <DPJNotariesSelect {...field?.widgetProps} {...field} form={form}/>
    </Form.Item>
  );
};
